module.exports = __webpack_public_path__ + "static/img/WOSB-Logo.18963c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Footer/WOSB-Logo.png
// module id = 819
// module chunks = 0